export interface UserDto {
  id: number
  role: UserRole
  activationId: number
  fullName?: string
}

export enum UserRole {
  ADMIN_SIGHTCALL = 'ADMIN_SIGHTCALL',
  CONTENT_MANAGER = 'CONTENT_MANAGER',
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
}
